import {
  Component,
  ComponentFactoryResolver, EventEmitter,
  Input,
  OnChanges, Output,
  QueryList,
  SimpleChanges,
  Type,
  ViewChildren
} from '@angular/core';
import { BannerLayoutType } from "./banner-layout.model";
import { BannerLayoutComponentModel } from "./banner-layout-component.model";
import { BannerContentModel } from "./banner-content-layout/banner-content.model";
import { ViewAnchorDirective } from "../../directives/view-anchor.directive";
import { TranslationService } from "../../services/wrapper/translation.service";
import { NotificationService } from "../../services/common/notification.service";

@Component({
  selector: 'app-component-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnChanges {

  private sub: any;

  @Input() isYellow: boolean = false;
  @Input() bannerLayoutType: BannerLayoutType;
  @Input() contentData: BannerContentModel;
  @Input() imgLayoutComponent: Type<any>;
  @Input() contentLayoutComponent: Type<any>;
  @Input() imgUrls: any[];
  @Input() selectedSlug: any;
  @Input() translations: any[];
  @Input() language: string;
  @Output() translateRefreshEmit:EventEmitter<any> = new EventEmitter<any>();

  show: boolean;

  @ViewChildren(ViewAnchorDirective) viewAnchor: QueryList<ViewAnchorDirective>;


  constructor(private componentFactoryResolver: ComponentFactoryResolver,
              private notificationService: NotificationService,
              public translationService: TranslationService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.translations) {
      const hide = this.translate(this.selectedSlug + '.' + this.contentData.show);
      this.show = (hide != 'hide');
      setTimeout(() => {
        this.loadComponents();
      }, 600);
    }
  }

  loadComponents() {
    const contentFactory = this.componentFactoryResolver.resolveComponentFactory(this.contentLayoutComponent);
    const imageFactory = this.componentFactoryResolver.resolveComponentFactory(this.imgLayoutComponent);

    this.viewAnchor.forEach((ad) => {
      const viewContainerRef = ad.viewContainerRef;
      viewContainerRef.clear();
      let componentRef;

      if (ad.isContent) {
        componentRef = viewContainerRef.createComponent<BannerLayoutComponentModel<any>>(contentFactory);
      } else {
        componentRef = viewContainerRef.createComponent<BannerLayoutComponentModel<any[]>>(imageFactory);
      }

      if (ad.data instanceof BannerContentModel) {
        ad.data.slug = this.selectedSlug;
      }

      componentRef.instance.data = ad.data;
      componentRef.instance.slug = this.selectedSlug;
      componentRef.instance.translations = this.translations;
      componentRef.instance.language = this.language;
      componentRef.instance.emit = this.translateRefreshEmit;
    })
  }

  translate(key: string) {
    let tmp = this.getTranslation(key);
    if(tmp.localizations) {
      const localization = tmp.localizations[this.language];
      return localization ? localization.value : "UNKNOWN";
    }
    return "UNKNOWN"
  }

  getTranslation(key: string) {
    return this.translationService.filterByKeyOnArray(key, this.translations);
  }

  changeShow() {
    const translation = this.getTranslation(this.selectedSlug + '.' + this.contentData.show);
    translation.localizations[this.language].value = (!this.show ? 'hide' : 'show');
    this.translationService.update(translation).subscribe(result => {
      this.notificationService.showSuccess("general.success");
    });
  }
}
